import { render, staticRenderFns } from "./MfaEmailDialog.vue?vue&type=template&id=23f71c6a"
import script from "./MfaEmailDialog.vue?vue&type=script&lang=js"
export * from "./MfaEmailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports